import React, { useState } from 'react'
import axios from 'axios'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useNavigate, Link } from 'react-router-dom'

import { isValidFileUploaded } from '../../../utils/isValidFileUploaded';
import '../../../styles/Admin.css'

const ADMIN_TESTIMONIALS_URL = 'admin/auth/testimonials'

const TestimonialsSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Name too short')
      .max(55, 'Name too long')
      .required('Required'),
    batch: Yup.string()
      .required('Required'),
    designation: Yup.string()
      .required('Required'),
    testimonial: Yup.string()
      .min(25, 'Too Short!')
      .required('Required'),
    image: Yup.string()
      .nullable(),
    order_no: Yup.number().positive('Only positive numbers')
      .required('Required'),
});

const AddTestimonials = () => {

    const [upImg, setupImg] = useState()
    const [loading, setLoading] = useState(false)

    const token = localStorage.getItem('token')
    const navigate = useNavigate()

    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="/admin/testimonials" className='breadcrumb__link'>
                        Testimonials   
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Add
                        </Link>
                    </Breadcrumbs>
                </div>
                <div className='section'>
                    <h3 className='section__header'>Add Testimonial</h3>
                    <Formik
                        initialValues={{
                            name: '',
                            batch: '',
                            designation: '',
                            testimonial: '',
                            image: '',
                            order_no: 999
                        }}
                        validationSchema={TestimonialsSchema}
                        onSubmit={async (data) => {
                            setLoading(true)
                            axios.post(`${process.env.REACT_APP_DEPT_API}/${ADMIN_TESTIMONIALS_URL}/add`, data, {
                                headers: {
                                    authorization: `Bearer ${token}`
                                }
                            }).then(() => {
                                setLoading(false)
                                alert("added successfully")
                                navigate('/admin/testimonials/')
                            }).catch(err => {
                                console.log(err)
                                alert("Error occured. Check console logs")
                            })
                        }}
                    >
                        {({ errors, values, setFieldValue }) => (
                            <Form className='admin_form_container'>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Name* </p>
                                    <label htmlFor="name">
                                        <Field className='admin_input' id="name" name="name" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.name}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Batch* </p>
                                    <label htmlFor="batch">
                                        <Field className='admin_input' id="batch" name="batch" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.batch}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Designation* </p>
                                    <label htmlFor="designation">
                                        <Field className='admin_input' id="designation" name="designation" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.designation}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Testimonial* </p>
                                    <label htmlFor="testimonial">
                                        <Field className='admin_input admin_textarea' as="textarea" id="testimonial" name="testimonial" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.testimonial}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label' htmlFor="image">Image </p>
                                    <p className='admin_label_small' htmlFor="image">Allowed formats: [.png, .jpeg, .jpg, .svg, .ico, .jfif, .webp] </p>
                                    <p className='admin_label_small' htmlFor="image">Max size: 10MB </p>
                                    <label >
                                        <input className='admin_input' id="file" name="image" type="file" onChange={(e) => {
                                            // converting image to base64 for cloudinary
                                            const file = e.target.files[0]
                                            if(isValidFileUploaded(file)){
                                                const reader = new FileReader()
                                                reader.readAsDataURL(file)
                                                reader.onloadend = () => {
                                                    setFieldValue("image", reader.result)
                                                    setupImg(reader.result)
                                                }
                                            } else {
                                                alert('Invalid file type / Size limit exceeded')
                                                e.target.value = null;
                                            }
                                        }} />
                                    </label>
                                    {upImg && (
                                        <div className='img_upload_preview'>
                                            <img src={upImg && upImg} alt="logo" style={{ width: "200px" }} />
                                        </div>
                                    )}
                                    <p className='admin_error_msg'>{errors.image}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Order Number* </p>
                                    <label htmlFor="order_no">
                                        <input className='admin_input' type="number" id="order_no" name="order_no" value={values.order_no} onChange={e => {
                                            setFieldValue("order_no", Number(e.target.value))
                                        }} />
                                    </label>
                                    <p className='admin_error_msg'>{errors.order_no}</p>
                                </div>
                                <button disabled={loading ? true: false} className='admin_btn' type="submit">
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    )
}

export default AddTestimonials